import { useState, useRef } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { FormGroup, Input, Label, Button } from "reactstrap";

import { translations } from "./../../i18/translations.js";
import Captcha from "./../../util/Captcha.js";
import JuniorDataForm from "./../admin/JuniorDataForm.js";

const JuniorRegistration = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const {lang, showAlert} = useOutletContext();
    const navigate = useNavigate();

    const [captchaToken, setCaptchaToken] = useState(null);

    const [userData, setUserData] = useState({
        id: "-1",
        nameprefix: null,
        fullname: null,
        pwd: null,
        pwdRe: null,
        institute: null,
        address: null,
        phone: null,
        email: null,
        statement: false,
        changePwd: true
    });

    const onCAPTCHASuccess = (token) => {
        setCaptchaToken(token);
    };

    const onCAPTCHAExpire = () => {
        setCaptchaToken(null);
    };

    const registJuniorData = () => {
        if (!userData.fullname) {
            showAlert({type: "alert-danger", message: "error_validation_fullname"});
        } else if (!userData.pwd || userData.pwd.length < 5) {
            showAlert({type: "alert-danger", message: "error_validation_pwd_length"});
        } else if (!userData.pwdRe || userData.pwd !== userData.pwdRe) {
            showAlert({type: 'alert-danger', message: 'forgot_pwd_err_mismatch'});
        } else if (!userData.email) {
            showAlert({type: "alert-danger", message: "error_validation_email"});
        } else if (!userData.institute) {
            showAlert({type: "alert-danger", message: "error_validation_institute"});
        } else {
            registrate();
        }
    };


    const registrate = async () => {
        try {
            const payload = {
                junior: userData,
                captchaToken: captchaToken
            };
            const response = await fetch(`${API_URL}/common/registrate_junior.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            showAlert(data.alert);
        } catch (error) {
            console.error("Error fetching members:", error);
        }
    };

    const back = () => {
        navigate("/ContentById/10160");
    };

    return (
            <>
            <h1 className="mbkegy-content">{translations[lang].junior_registration}</h1>
            
            <JuniorDataForm junior={userData} onChange={setUserData}/>
            
            <Captcha onVerify={onCAPTCHASuccess} onCaptchaExpire={onCAPTCHAExpire} />
            
            <Button color="primary" onClick={registJuniorData} disabled={captchaToken === null}>{translations[lang].junior_registrate}</Button>
            <Button color="secondary" onClick={back}>{translations[lang].cancel}</Button>
            </>
            );
};

export default JuniorRegistration;
